<template>
  <div class="p-3">
    <!--标题部分-->
    <public-title>
      <span>订单详情页</span>
    </public-title>
    <!--订单基本详情-->
    <div style="box-shadow:2px 2px 5px #eee;" class="pb-5" id="admin_yearcard">
      <h2 class=" pt-3 pb-3 border-bottom">{{CardInfoList.title === '' ? '游客' : CardInfoList.title}}</h2>
      <p class="text-left pl-5 pt-2 d-flex mt-4">
        <left-text left-text="订单号"/>
        <span class="text-muted">{{CardInfoList.order_no}}</span></p>
      <p class="text-left pl-5 pt-2 d-flex" v-if="CardInfoList.title!==''">
        <left-text left-text="名称"/>
       <span class="text-muted">{{CardInfoList.title}}</span></p>
      <p class="text-left pl-5 pt-2 d-flex">
        <left-text left-text="联系人"/>
        <span class="text-muted">{{CardInfoList.contact}}</span></p>
      <p class="text-left pl-5 pt-2 d-flex">
        <left-text left-text="联系电话"/>
        <span class="text-muted">{{CardInfoList.mobile}}</span></p>
      <p class="text-left pl-5 pt-2 d-flex">
        <left-text left-text="收件地址"/>
        <span class="text-muted">{{CardInfoList.address}}</span></p>
      <p class="text-left pl-5 pt-2 d-flex">
        <left-text left-text="运费"/>
        <span class="text-muted">{{CardInfoList.express_price}} 元</span></p>
      <p class="text-left pl-5 pt-2 d-flex">
        <left-text left-text="购买数量"/>
        <span class="text-muted">{{CardInfoList.num}} 张</span></p>
      <p class="text-left pl-5 pt-2 d-flex">
        <left-text left-text="总价款"/>
        <span class="text-muted">{{CardInfoList.price}} 元</span></p>
      <p class="text-left pl-5 pt-2 d-flex">
        <left-text left-text="发布时间"/>
        <span class="text-muted">{{CardInfoList.time | formatTimestamp(1)}}</span></p>
      <p class="text-left pl-5 pt-2 d-flex">
        <left-text left-text="当前状态"/>
        <span :class="[{'text-danger':CardInfoList.status===2},{'text-success':CardInfoList.status===3}]">{{status}}</span>
      </p>
      <p class="text-left pl-5 pt-2 d-flex align-items-center" v-if="CardInfoList.status !== 1">
        <left-text left-text="快递名称"/>
        <el-input v-if="CardInfoList.status === 2" v-model="expressName" placeholder='请输入快递名称' class="w-50"></el-input>
        <span class="text-muted" v-if="CardInfoList.status === 3">{{CardInfoList.express_name}}</span>
      </p>
      <p class="text-left pl-5 pt-2 d-flex align-items-center" v-if="CardInfoList.status !== 1">
        <left-text left-text="快递单号"/>
        <el-input v-if="CardInfoList.status === 2" v-model.number ="expressNum" placeholder="请输入快递单号" class="w-50"></el-input>
        <span class="text-muted" v-if="CardInfoList.status === 3">{{CardInfoList.express_num}}</span>
      </p>
      <p class="text-left pl-5 pt-2 d-flex justify-content-center" v-if="CardInfoList.status === 2">
        <el-button type="primary" size="small" @click="validateForm">确认发货</el-button>
      </p>
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions} from 'vuex'
  import LeftText from '../../../components/PublicComp/LeftText';

  export default {
    name: 'YearCardVerify',
    components: {LeftText},
    data() {
      return {
        expressName: '顺丰快递',                             //快递名称
        expressNum: '',                                      //快递单号
      }
    },
    created() {
      this.getYearCardInfo({
        id: this.queryId
      })
    },
    computed: {
      ...mapState(['userLoginMessage', 'CardInfoList']),
      queryId() {
        return this.$route.query.data;
      },
      status() {
        let arr = '';
        this.$GVAR.yearCardStatus.forEach(item => {
          if (item.id === this.CardInfoList.status) arr = item.name;
        });
        return arr;
      }
    },
    methods: {
      ...mapActions(['getYearCardInfo','saveYearCardInfo']),
      /*输入框检测*/
      validateInput() {
        if (this.expressName === '') return {msg: '请输入快递名称', code: false};
        if (this.expressNum === '') return {msg: '请输入快递单号', code: false};
        else return {msg: '表单验证通过', code: true}
      },
      /*表单验证*/
     async validateForm() {
        let result = this.validateInput();
        if (result.code) {
         let res = await this.saveYearCardInfo({
              id: this.queryId,
              express_name: this.expressName,
              express_num: this.expressNum
          });
         if (res.code === '00000')  {
           this.getYearCardInfo({
             id: this.queryId,
           })
         }
        } else {
          this.$alert(result.msg, '提示', {
            confirmButtonText: '确定'
          });
        }
      },
    }
  }
</script>
